import * as React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Container,
  Divider,  
  Link as MuiLink,
  Stack,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/GridLegacy";
const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <Box component="footer" sx={{ mt: 6, borderTop: "1px solid", borderColor: "divider", bgcolor: "background.paper" }}>
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Grid container spacing={3}>
          {/* Company */}
          <Grid item xs={12} md={5}>
            <Typography variant="h6" fontWeight={900} gutterBottom>
              BhamuIntelli Systems LLP
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
              Education-focused software development—platforms, assessments, and modern cloud-native delivery.
            </Typography>

            <Stack spacing={0.5}>
             
            <Typography variant="body2" color="text.secondary">
              <strong>Main Product:</strong>{' '}
              <a href="https://www.studytunnel.com" target="_blank" rel="noopener noreferrer">
                https://www.studytunnel.com
              </a>
            </Typography>

               <Typography variant="body2" color="text.secondary">
                <strong>LLPIN:</strong> ACR-5927
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Registered Address:</strong> SNO 5/2/1 Daffodils, Gulmohar City, Kharadi, Viman Nagar,
                Pune 411014, Maharashtra, India
              </Typography>
            </Stack>
          </Grid>

          {/* Contact */}
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" fontWeight={800} gutterBottom>
              Contact
            </Typography>

            <Stack spacing={1}>
              <Typography variant="body2" color="text.secondary">
                <strong>Phone:</strong>{" "}
                <MuiLink href="tel:+919096272737" underline="hover">
                  +91 9096272737
                </MuiLink>
              </Typography>

              <Typography variant="body2" color="text.secondary">
                <strong>Email:</strong>{" "}
                <MuiLink href="mailto:bis9.llp@gmail.com" underline="hover">
                  bis9.llp@gmail.com
                </MuiLink>
                <br/>
                <MuiLink href="mailto:neha@studytunnel.com" underline="hover">
                  neha@studytunnel.com
                </MuiLink>
              </Typography>

              <Typography variant="caption" color="text.secondary">
                For official documents (e.g., PAN/TAN), we share details on request during contracting.
              </Typography>
            </Stack>
          </Grid>
      
          {/* Links */}
          <Grid item xs={12} md={3}>
            <Typography variant="subtitle1" fontWeight={800} gutterBottom>
              Legal
            </Typography>

            <Stack spacing={1}>
              <MuiLink component={RouterLink} to="/privacy-policy" underline="hover">
                Privacy Policy
              </MuiLink>
              <MuiLink component={RouterLink} to="/legal-compliance" underline="hover">
                Legal & Compliance
              </MuiLink>
              <MuiLink component={RouterLink} to="/terms-of-service" underline="hover">
                Terms of Service
              </MuiLink>
              <MuiLink component={RouterLink} to="/contact-us" underline="hover">
                Contact Us
              </MuiLink>
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3 }} />

        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          spacing={1}
        >
          <Typography variant="caption" color="text.secondary">
            © {year} BhamuIntelli Systems LLP. All rights reserved.
          </Typography>

          <Typography variant="caption" color="text.secondary">
            Built with modern web technologies • Hosted with HTTPS
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
